import log from "loglevel";

import config from "@/config";

if (!["production", "staging"].includes(config.buildEnv || "")) log.enableAll();
else log.setLevel("error");

export default log;
